module.exports = __webpack_public_path__ + "img/image8.2aa7676b.webp";